import { render, staticRenderFns } from "./ui-table.vue?vue&type=template&id=ea9121d0&scoped=true"
import script from "./ui-table.vue?vue&type=script&lang=js"
export * from "./ui-table.vue?vue&type=script&lang=js"
import style0 from "./ui-table.vue?vue&type=style&index=0&id=ea9121d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9121d0",
  null
  
)

export default component.exports